/* istanbul ignore file */
export * from './DisplaySettingsDesktopPagination';
